import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

interface Props {
  width: number;
  height: number;
}

const GaugeChartSkeleton = ({ width, height }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        gap: '15px',
      }}
    >
      <Skeleton width={50} height={40} />
      <Skeleton
        variant="rectangular"
        animation="pulse"
        sx={{
          width,
          height: height,
          borderRadius: `${width}px ${width}px 0 0`,
        }}
      />
      <Skeleton width={100} height={40} />
    </Box>
  );
};

export default GaugeChartSkeleton;
